<template>
  <div class="container__card order-card" id="card">
    <div class="wrapper-position" @click="checkFoMobileAndNavigate()">
      <div id="brand-logo" class="brand-logo">
        <img :src="brandLogo" class="left-padding" v-if="brandLogo" :class="logoPosition">
        <p :style="themeColor" class="title left-padding">Your Order</p>
      </div>
      <div class="order-card-wrapper">
        <div class="body-content" :class="{'multiple-line-items': checkout.lineItems.length > 1}">
          <div :style="themeColor" class="sub-heading items">
          <div class="clearfix">
            <template v-if="checkout.lineItems.length == 1">
              <p class="text-large amount">
                {{totalAmount}}
                <span class="single-item-tax" id="single-item-tax"> + taxes extra</span>
              </p>
              <p class="text-large package-name">
                {{checkout.lineItems[0].name}}
              </p>
              <p class="description">
                {{checkout.lineItems[0].description}}
              </p>
            </template>
            <template v-else>
                <div class="left">
                  <p class="text-large amount">{{totalAmount}}</p>
                  <p v-if="checkout.itemsWithoutDiscounts().length > 1" class="text-large">{{checkout.itemsWithoutDiscounts().length}} items in total</p>
                  <p v-if="checkout.itemsWithoutDiscounts().length == 1" class="text-large">{{checkout.itemsWithoutDiscounts()[0].name}} </p>
                </div>
            </template>
          </div>
          <p class="shipping-text" ><a @click="prev()">Change</a></p>
          </div>
        </div>

        <div class="total">
          <div class="clearfix discount" v-if="checkout.discountItems().length >= 1">
            <div class="dim clearfix">
                <p class="left">Discount</p>
                <p class="total-text">-{{checkout.discountsWithSymbol()}}</p>
            </div>
          </div>
          <div class="total-footer clearfix" v-if="checkout.lineItems.length > 1 || isMobile">
            <p class="left" id="tax-text">Your final bill amount.</p>
            <p class="right total-bill show"  :class="{'border-top' : checkout.discountItems().length >= 1}">{{finalAmount}}</p>
          </div>
          <!-- Discount code -->
          <template v-if="showCouponSection">
            <p class="coupon" v-show="!discountCodeShown" @click="discountCodeShown = true">Have a discount code?</p>
            <div class="new-user-dicount-section clearfix" v-show="discountCodeShown">
              <input type="text" v-model="discountCode" placeholder="Enter Code" class="left">
              <button class="theme-background right" @click="applyCoupon($event)">APPLY</button>
            </div>
          </template>
        </div>
        <div class="copyright" id="copyright">
          <p @click="initAboutCB()"><i class="fa fa-lock" aria-hidden="true"></i>Secured by Chargebee</p>
          <div class="secured-content" :class="{'show': showAboutChargebee}">
              <p>Chargebee is PCI level 1 complaint, which means your information is very safe</p>
              <!-- <div class="img-container">
                  <span><img src="img/secure1.png"></span>
                  <span><img src="img/pci.png"></span>
                  <span><img src="img/trust.png"></span>
              </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">

  export default {
    name: 'checkout-step-order-summary',
    props: ["checkout"],
    computed: {
      totalAmount() {
        // TODO figure out how to share common helpers among components
        return this.checkout.totalAmount();
      },

      finalAmount() {
        return this.checkout.finalAmount();
      }
    },
    data() {
      return {
        discountCode: "",
        discountCodeShown: false,
        showCouponSection: this.checkout.discountItems().length == 0,
        showAboutChargebee: false
      }
    },
    methods: {
      prev() {
        document.getElementById("app").classList.add("reverse-animation");
        var container = document.querySelectorAll(".wrapper-position")[0];
        container.classList.remove("card-position");
        window.setTimeout(function() {
          document.getElementById("app").classList.remove("expand");
          window.setTimeout(function() {
            this.checkout.currentStep = 0;
          }.bind(this), 300);
        }.bind(this), 700);
      },
      applyCoupon(event) {
        this.checkout.applyCoupon(this.coupon);
        this.showCouponSection = false;
      },

      initAboutCB() {
        if(!this.showAboutChargebee) {
          setTimeout(function(){
            this.showAboutChargebee = false;
          }.bind(this), 2000);
        }
        this.showAboutChargebee = !this.showAboutChargebee;
      },
      checkFoMobileAndNavigate(event) {
        if(this.isMobile) {
          this.checkout.currentStep = 0;
        }
      }
    }
  }
</script>

<style scoped>
  .new-user-dicount-section{
    margin-top: 10px;
  }
</style>


// WEBPACK FOOTER //
// CheckoutStepOrderSummary.vue?3c7a9224